/**
 * Kleine geteilte Konstanten fuer `AuftragEckdatenKarte.tsx` + `GaestezahlAbweichungHinweis.tsx`
 * (PR4, `docs/PLAN-EVENT-FELD-VERSIONIERUNG.md` Abschnitt 4.4) — ausgelagert, damit die Extraktion
 * von `GaestezahlAbweichungHinweis` dieselben Tailwind-Klassen/denselben Text verwendet wie die
 * Karte, statt sie ein zweites Mal abzutippen (Drift-Gefahr).
 */
export const ROW_LABEL = "font-body-sm text-body-sm text-secondary dark:text-secondary-fixed-dim";

/** Text der Übernahme-Sperre (`OFFER_LOCKED_STATUSES`, ab `offer_chosen`) — sperrt NUR die
 *  Angebots-Übernahme-Aktion, NICHT mehr die Eckdaten-Felder selbst (die Feld-Sperre ist mit PR3/
 *  PR4 entfallen, s. Kopfkommentar `AuftragEckdatenKarte.tsx`). */
export const GESPERRT_HINWEIS = "Nach Annahme gesperrt";
